import { getHost } from './selectors';

export default function withOriginServerHeader(procedureObject) {
  return {
    ...procedureObject,
    call: ({
      fetchClient,
      getState,
      args: {
        headers,
        ...args
      } = {},
      ...opts
    }) => {
      const state = getState();
      const host = getHost(state);

      const updatedHeaders = {
        ...headers,
        ...!global.BROWSER ? {
          origin: `https://${host}`,
        } : {},
      };

      return procedureObject.call({
        fetchClient,
        getState,
        args: {
          ...Object.keys(updatedHeaders).length > 0 ? { headers: updatedHeaders } : {},
          ...args,
        },
        ...opts,
      });
    },
  };
}
